/**
 * @file  LayoutBackTop/index.ts
 * @description  Buttons for scrolling to the top of the app
 *
 * @author ogarcia (ozkary)
 *
 */
import { BackTop } from 'antd';

/**
 * export the element
 */
export const LayoutBackTop = BackTop;
